
// 辅助函数
function formatDate(date) {
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, '0');
  const d = String(date.getUTCDate()).padStart(2, '0');
  // return `${y}-${m}-${d}`;
  return `${y}${m}${d}`;
}


/**
 * 获取包含今天在内的过去 7 天的日期列表（从旧到新）
 * @param {Date|string|number} baseDate - 可选，基准日期（默认今天）
 * @returns {string[]} 长度为 7 的数组，格式 "YYYY-MM-DD"
 */
function getLast7Days(baseDate = new Date()) {
  const result = [];
  const date = new Date(baseDate); // 复制一份，防止修改原对象

  // 先把时间归零，避免夏令时等问题影响日期计算
  date.setUTCHours(0, 0, 0, 0);

  for (let i = 6; i >= 0; i--) {
    const d = new Date(date);
    d.setUTCDate(date.getUTCDate() - i); // 倒退 0~6 天
    result.push(formatDate(d));
  }

  return result;
}

function getLast7DaysDesc(baseDate = new Date()) {
  const result = [];
  const date = new Date(baseDate);
  date.setUTCHours(0, 0, 0, 0);

  for (let i = 0; i < 7; i++) {
    const d = new Date(date);
    d.setUTCDate(date.getUTCDate() - i);
    result.push(formatDate(d));
  }
  return result;
}

/**
 * 获取包含今天在内的过去 30 天的日期列表（从旧到新）
 * @param {Date|string|number} baseDate - 可选基准日期，默认今天
 * @returns {string[]} 长度为 30 的数组，格式 "YYYY-MM-DD"
 */
function getLast30Days(baseDate = new Date()) {
  const result = [];
  const date = new Date(baseDate);
  date.setUTCHours(0, 0, 0, 0); // 归零时间，避免夏令时影响

  for (let i = 29; i >= 0; i--) {  // i=29 → 29天前，i=0 → 今天
    const d = new Date(date);
    d.setUTCDate(date.getUTCDate() - i);
    result.push(formatDate(d));
  }

  return result;
}

function getLast30DaysDesc(baseDate = new Date()) {
  const result = [];
  const date = new Date(baseDate);
  date.setUTCHours(0, 0, 0, 0);

  for (let i = 0; i < 30; i++) {
    const d = new Date(date);
    d.setUTCDate(date.getUTCDate() - i);
    result.push(formatDate(d));
  }
  return result;
}

/**
 * 获取「自然过去一个月」的日期列表（包含今天）
 * 规则：回到上个月的“同一天”，如果上个月没有那天，则取上个月最后一天
 * @param {Date|string|number} baseDate - 基准日期，默认今天
 * @param {boolean} newestFirst - true=今天在前，false=最老日期在前（默认旧→新）
 * @returns {string[]} 格式 "YYYY-MM-DD" 的日期数组
 */
function getLastNaturalMonth(baseDate = new Date(), newestFirst = false) {
  const endDate = new Date(baseDate);
  endDate.setUTCHours(0, 0, 0, 0);

  const year = endDate.getUTCFullYear();
  const month = endDate.getUTCMonth(); // 0~11
  const day = endDate.getUTCDate();

  // 计算「上个月同一天」
  let startDate = new Date(year, month - 1, day);
  
  // 如果上个月没有这一天（比如 3月31日 → 2月），自动变成上个月最后一天
  // JavaScript 会自动处理：new Date(2025, 1, 31) → 2025-03-03（不对！）
  // 所以要手动修正：
  if (startDate.getMonth() !== (month - 1 + 12) % 12) {
    // 说明溢出了，取上个月的最后一天
    startDate = new Date(year, month, 0); // month=0 → 去年12月31日
  }

  const result = [];
  const current = new Date(startDate);

  while (current <= endDate) {
    result.push(formatDate(current));
    current.setUTCDate(current.getUTCDate() + 1);
  }

  // 按需求调整顺序
  return newestFirst ? result.reverse() : result;
}

/**
 * 获取包含今天在内的过去 N 天的日期列表
 * @param {number} days - 要获取的天数（必须 ≥ 1）
 * @param {Date|string|number} baseDate - 可选：基准日期，默认今天
 * @param {boolean} newestFirst - 可选：true=今天在最前面，false=最老的在最前面（默认从旧到新）
 * @returns {string[]} 长度为 days 的数组，格式 "YYYY-MM-DD"
 */
function getLastDays(days, baseDate = new Date(), newestFirst = false) {
  if (!Number.isInteger(days) || days < 1) {
    throw new Error('days 必须是大于等于 1 的整数');
  }

  const result = [];
  const date = new Date(baseDate);
  date.setUTCHours(0, 0, 0, 0); // 防止夏令时影响

  const total = days - 1; // 因为包含今天，所以要减去 1

  if (newestFirst) {
    // 从今天开始往前推（新 → 旧）
    for (let i = 0; i < days; i++) {
      const d = new Date(date);
      d.setUTCDate(date.getUTCDate() - i);
      result.push(formatDate(d));
    }
  } else {
    // 从最老的开始往今天推（旧 → 新）
    for (let i = total; i >= 0; i--) {
      const d = new Date(date);
      d.setUTCDate(date.getUTCDate() - i);
      result.push(formatDate(d));
    }
  }

  return result;
}
// ==================== 测试验证

export const DateUtils = {
  getLast7Days,
  getLast7DaysDesc,
  getLast30Days,
  getLast30DaysDesc,
  getLastNaturalMonth,
  getLastDays,
};